/** @task: #71168 Agro - Tela de listagem de Planejamento de safra */
<template>
    <div id="main">
        <div class="page" v-show="!rotaAninhada">
            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t("agro-planosafra") }}
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{
                                        $t("agro")
                                    }}</a>
                                </li>
                                <li>
                                    <a aria-current="page">{{
                                        $t("agro-planosafra")
                                    }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            v-if="permissao.create"
                            class="save-btn"
                            type="button"
                            tag="button"
                            @click="
                                $router.push({ name: 'agro-planosafra-new' })
                            "
                        >
                            {{ $t("adicionar") }}
                        </button>
                    </div>
                </div>

                <div class="columns">
                    <div class="column is-6">
                        <search-bar
                            :onSearch="debouncedOnSearch"
                            tooltipLabel="msg-campo-busca-plano-safra"
                        />
                    </div>

                    <div class="column is-3">
                        <vss-select
                            ref="empresaInput"
                            title="empresa"
                            placeholder="selecione"
                            :options="empresaSelect"
                            v-model="empresaSelected"
                            :loading="empresasLoading"
                            @search="carregarEmpresas"
                            :height="40"
                            multiple
                        />
                    </div>

                    <div class="column is-3">
                        <vss-select
                            ref="safraInput"
                            title="safra"
                            placeholder="selecione"
                            :options="safraSelect"
                            @search="loadSafras"
                            v-model="safraSelected"
                            :height="40"
                            clearable
                            multiple
                            searchable
                            :closeOnSelect="false"
                        />
                    </div>
                </div>
                <!-- FILTROS EXTRAS -->
                <div class="filtros-extras">
                    <FiltroSafra
                        @update-filtro="updateFiltro"
                        ref="filtroRef"
                        :limparFiltros="limparFiltros"
                        @filtrosLimpos="limparFiltros = $event"
                    />
                </div>
                <!-- BOTÕES -->
                <div class="columns mt-2 mb-1">
                    <div class="column is-6 has-text-centered">
                        <button
                            class="delete-btn pl-4 pr-4"
                            @click="confirmCleanFilters"
                        >
                            {{ $t("limpar-filtros") }}
                        </button>
                    </div>
                    <div class="column is-6 has-text-centered">
                        <button
                            class="save-btn pl-4 pr-4"
                            @click="carregarDados()"
                        >
                            {{ $t("pesquisar") }}
                        </button>
                    </div>
                </div>

                <div class="registry-wrapper">
                    <container-loader
                        v-if="isLoading && !$store.getters.isLoading"
                    />
                    <empty-table-message v-if="isEmpty" />
                    <b-table
                        v-else
                        :data="planosafra"
                        class="data-table"
                        @sort="sortTable"
                        backend-sorting
                    >
                        <b-table-column
                            v-for="(f, i) in fields"
                            :key="i"
                            :field="f.key"
                            :label="f.key != 'excluir' ? $t(f.key) : ''"
                            :width="f.width"
                            :class="{
                                'excluir-field': f.key == 'excluir',
                                'label-km': f.key == 'label',
                            }"
                            :sortable="f.sortable"
                            :custom-sort="f.sortFn"
                        >
                            <template v-slot="props">
                                <div v-if="f.key == 'safra'">
                                    <router-link
                                        :to="{
                                            name: 'agro-planosafra-edit',
                                            params: { id: props.row.uuid },
                                        }"
                                    >
                                        <span>{{ props.row[f.key] }}</span>
                                    </router-link>
                                </div>

                                <div v-else-if="f.key == 'codigo'">
                                    <span>{{
                                        props.row.idagro_planosafraerp
                                    }}</span>
                                </div>

                                <div v-else-if="f.key == 'situacao'">
                                    <b-tag
                                        :class="{
                                            'is-orange':
                                                props.row.situacao == 4,
                                            'is-success':
                                                props.row.situacao == 1,
                                            'is-danger':
                                                props.row.situacao == 0,
                                        }"
                                    >
                                        {{
                                            props.row.situacao > 0
                                                ? props.row.situacao == 4
                                                    ? $t("aberto")
                                                    : $t("fechado")
                                                : $t("excluido")
                                        }}
                                    </b-tag>
                                </div>

                                <div v-else>
                                    {{ props.row[f.key] }}
                                </div>
                            </template>
                        </b-table-column>
                    </b-table>
                    <PaginationViewer
                        class="mb-0"
                        :resetPagination="pagination.resetPagination"
                        :totalItems="pagination.totalRows"
                        :perPageOptions="pagination.perPageOptions"
                        :optionStarted="pagination.optionStarted"
                        @change="updatePagination"
                    />
                </div>
            </div>
        </div>
        <router-view />
    </div>
</template>

<script>
import EmpresaService from "@/services/vendas/empresa/EmpresaService";
import ContainerLoader from "@/components/content/loader/ContainerLoader";
import PlanoSafraService from "@/services/agro/planosafra/PlanoSafraService";
import SafraService from "@/services/agro/SafraService";
import HideInfo from "@/components/shared/HideInfo";
import { mapState } from "vuex";
import FiltroSafra from "@/components/agro/planosafra/FiltroPlanoSafra";

export default {
    beforeRouteUpdate(to, from, next) {
        if (
            to.name.includes("agro-planosafra") &&
            to.name != "agro-planosafra-list"
        ) {
            this.rotaAninhada = true;
            next();
        } else {
            this.rotaAninhada = false;
            this.carregarDados(this.pagination.currentPage);
            next();
        }
    },
    components: {
        ContainerLoader,
        HideInfo,
        FiltroSafra,
    },
    data() {
        return {
            rotaAninhada: false,
            cleanHide: true,
            planosafra: [],
            empresaService: new EmpresaService(this.$http, this.$router),
            service: new PlanoSafraService(this.$http, this.$router),
            safraService: new SafraService(this.$http, this.$router),
            fields: [
                { key: "codigo", width: null, sortable: true, sortFn: null },
                { key: "safra", width: null, sortable: true, sortFn: null },
                { key: "cultura", width: null, sortable: true, sortFn: null },
                { key: "cultivar", width: null, sortable: true, sortFn: null },
                { key: "cliente", width: null, sortable: true, sortFn: null },
                { key: "empresa", width: null, sortable: true, sortFn: null },
                { key: "usuario", width: null, sortable: true, sortFn: null },
                { key: "origem", width: null, sortable: false, sortFn: null },
                { key: "situacao", width: null, sortable: false, sortFn: null },
            ],
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            delete: null,
            queryFilter: "",
            column: "datahorainc",
            order: "desc",
            permissao: {},
            empresas: {},
            safras: {},
            empresaSelect: [],
            empresaSelected: [],
            safraSelect: [],
            safraSelected: [],
            filtros: {
                cliente: [],
                propriedade: [],
                area: [],
                talhao: [],
                usuario: [],
                cultura: [],
                cultivar: [],
                niveltecnologico: [],
                dataInicio: new Date(this.$moment().subtract(30, "days")),
                dataFim: new Date(),
                status: 0,
            },
            limparFiltros: false,
            empresasLoading: false,
        };
    },
    created() {
        this.rotaAninhada = (this.$route.name != 'agro-planosafra-list');

        this.pagination.perPage =
            this.pagination.perPageOptions[this.pagination.optionStarted];
        this.permissao = this.hasPermissionAccess(
            "agro",
            "agro-planosafra",
            "agro-planosafra"
        );

        if (!this.permissao.read) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "agro-planosafra" },
            });
        } else {
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
            this.carregarDados();
            // já carrega pelo @search="loadSafras"
            // this.loadSafras();
            this.carregarEmpresas("");
        }
    },
    computed: {
        ...mapState(["hide"]),
    },
    methods: {
        updateFiltro(filtro) {
            switch (filtro.nomeFiltro) {
                case "cliente":
                    this.filtros.cliente = filtro.valor;
                    break;
                case "propriedade":
                    this.filtros.propriedade = filtro.valor;
                    break;
                case "area":
                    this.filtros.area = filtro.valor;
                    break;
                case "talhao":
                    this.filtros.talhao = filtro.valor;
                    break;
                case "usuario":
                    this.filtros.usuario = filtro.valor;
                    break;
                case "cultura":
                    this.filtros.cultura = filtro.valor;
                    break;
                case "cultivar":
                    this.filtros.cultivar = filtro.valor;
                    break;
                case "niveltecnologico":
                    this.filtros.niveltecnologico = filtro.valor;
                    break;
                case "inicio":
                    this.filtros.dataInicio = filtro.valor;
                    break;
                case "fim":
                    this.filtros.dataFim = filtro.valor;
                    break;
            }
        },

        limparFiltrosCall() {
            this.empresaSelected = [];
            this.safraSelected = [];
            this.filtros.cliente = [];
            this.filtros.propriedade = [];
            this.filtros.area = [];
            this.filtros.talhao = [];
            this.filtros.usuario = [];
            this.filtros.cultura = [];
            this.filtros.cultivar = [];
            this.filtros.niveltecnologico = [];
            this.filtros.dataInicio = new Date(
                this.$moment().subtract(30, "days")
            );
            this.filtros.dataFim = new Date();
            this.filtros.status = 0;
            this.limparFiltros = true;
            this.carregarDados();
        },

        confirmCleanFilters() {
            this.$root.confirm({
                message: this.$t("msg-confirm-limpar-filtros"),
                onConfirm: () => this.limparFiltrosCall(),
            });
        },

        infoIsHidden() {
            this.$store.dispatch("infoIsHidden", {
                infoIsHidden: !this.hide.infoIsHidden,
            });
        },

        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },

        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },

        carregarDados(currentPage = 1) {
            this.cleanHide = true;
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoading = true;

            let filtros = {
                empresas: this.empresaSelected
                    ? this.empresaSelected.map((e) => e.id)
                    : [],
                safras: this.safraSelected
                    ? this.safraSelected.map((e) => e.id)
                    : [],
                clientes: this.filtros.cliente
                    ? this.filtros.cliente.map((e) => e.idcliente)
                    : [],
                propriedades: this.filtros.propriedade
                    ? this.filtros.propriedade.map((e) => e.uuid)
                    : [],
                areas: this.filtros.area
                    ? this.filtros.area.map((e) => e.uuid)
                    : [],
                talhoes: this.filtros.talhao
                    ? this.filtros.talhao.map((e) => e.uuid)
                    : [],
                culturas: this.filtros.cultura
                    ? this.filtros.cultura.map((e) => e.id)
                    : [],
                cultivar: this.filtros.cultivar
                    ? this.filtros.cultivar.map((e) => e.id)
                    : [],
                usuarios: this.filtros.usuario
                    ? this.filtros.usuario.map((e) => e.id)
                    : [],
                niveltecnologico: this.filtros.niveltecnologico
                    ? this.filtros.niveltecnologico.map(
                            (e) => e.idagroniveltecnologico
                      )
                    : [],
                inicio: this.filtros.dataInicio
                    ? this.$moment(this.filtros.dataInicio).format("YYYY-MM-DD")
                    : null,
                fim: this.filtros.dataFim
                    ? this.$moment(this.filtros.dataFim)
                            .format("YYYY-MM-DD")
                    : null,
            };

            let params = [this.queryFilter != "" ? this.queryFilter : ".*"];

            this.service
                .findAll(
                    filtros,
                    this.column,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    params
                )
                .then(this.mapItems)
                .then((value) => {
                    this.planosafra = value;
                    this.isEmpty = this.planosafra.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage("error", "msg-erro-load");
                    console.error("Erro ao carregar os planos de safra.");
                })
                .finally((_) => {
                    this.cleanHide = false;
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            return body.content.map((m) => {
                return {
                    idagro_planosafraerp: m.idagro_planosafraerp,
                    cliente: m.cliente.nome,
                    cultura: m.tipocultura.descricao,
                    safra: m.safra.descricao,
                    cultivar: m.cultivar ? m.cultivar.descricao : "---",
                    usuario: m.usuario.nome,
                    empresa: m.empresa.nome,
                    uuid: m.uuid,
                    origem: m.origem,
                    situacao: m.situacao,
                };
            });
        },
        /*
                @84626
                retornar empresas que estão associadas a um usuário informado. Caso o usuário for admin,
                retorna todas as empresas
            */
        carregarEmpresas(q) {
            this.empresasLoading = true;
            this.empresaService
                .findList(q)
                .then((r) => {
                    if (r.status != 200) {
                        console.error(
                            `[PLANO SAFRA] Erro status ${r.status} ao carregar empresas.`
                        );
                        console.error(`[PLANO SAFRA] Mensagem: ${r.message}`);
                    } else {
                        this.empresaSelect = r.content.map((e) => {
                            return {
                                id: e.idempresa,
                                label: e.nome,
                            };
                        });
                    }
                })
                .catch((e) => {
                    console.error("[PLANO SAFRA] Erro ao carregar empresas.", e);
                })
                .finally((_) => {
                    this.empresasLoading = false;
                });
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados();
        },

        loadSafras(query) {
            query = this.isNull(query) ? '.*' : this.removeToSearch(query)

            this.isLoading = true;
            this.safraService
                .findAllComboSituacao(2, query)
                .then(this.mapSafras)
                .then((value) => {
                    this.safraSelect = value;
                })
                .catch((e) => {
                    console.error(e);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        mapSafras(body) {
            return body.content.map((i) => {
                return {
                    id: i.idsafra,
                    label: i.situacao != 1 ? 'Inativo | '+ i.descricao : i.descricao,
                    situacao: i.situacao
                };
            });
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;

    .page {
        position: relative;
        padding-left: 0;
    }

    .tag {
        width: 100%;
    }

    .is-orange {
        background-color: #ef8419;
        color: #fff;
    }
}
</style>
